export default "__VITE_ASSET__vFAThxkm__"